import { getAuth } from "firebase/auth";
import { addDoc, collection, getFirestore, onSnapshot } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

export const getCheckoutUrl = async (priceId, enableTrial = true) => {
  const auth = getAuth();
  const userId = auth.currentUser ? auth.currentUser.uid : null;
  if (!userId) throw new Error("User is not authenticated");

  const db = getFirestore();
  const checkoutSessionRef = collection(db, "customerDetails", userId, "checkout_sessions");

  const docRef = await addDoc(checkoutSessionRef, {
    price: priceId,
    success_url: 'https://app.optimind-ai.com/pages/profile-overview',
    cancel_url: window.location.origin,
    allow_promotion_codes: true,
    //trial_from_plan: true,
    trial_period_days: 7, 
  });

  return new Promise((resolve, reject) => {
    const unsubscribe = onSnapshot(docRef, (snap) => {
      const data = snap.data();
      const error = data ? data.error : null;
      const url = data ? data.url : null;

      if (error) {
        unsubscribe();
        reject(new Error(`An error occurred: ${error.message}`));
      }
      if (url) {
        console.log("Stripe Checkout URL:", url);
        unsubscribe();
        resolve(url);
      }
    });
  });
};

export const getPortalUrl = async (app) => {
  const auth = getAuth(app);
  const user = auth.currentUser;

  let dataWithUrl;
  try {
    const functions = getFunctions(app, "us-central1");
    const functionRef = httpsCallable(functions, "ext-firestore-stripe-payments-createPortalLink");
    const response = await functionRef({ customerId: user ? user.uid : null, returnUrl: 'https://app.optimind-ai.com/applications/pricing' });
    dataWithUrl = response.data;

    console.log("Reroute to Stripe portal: ", dataWithUrl.url);
  } catch (error) {
    console.error(error);
  }

  return new Promise((resolve, reject) => {
    if (dataWithUrl && dataWithUrl.url) {
      resolve(dataWithUrl.url);
    } else {
      reject(new Error("No url returned"));
    }
  });
};
